var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91697 6.80283L7.60756 1.99849C7.65782 1.94702 8.05987 1.53522 8.69645 1.31216C9.58431 1.02047 10.4889 1.26069 11.2093 1.99849C11.9464 2.7363 12.1641 3.6457 11.8793 4.55509C11.6783 5.20711 11.2595 5.65322 11.2093 5.7047L6.16688 10.8694C5.29577 11.7616 3.118 12.9112 1.10775 10.8694C-0.885754 8.82752 0.253389 6.57978 1.10775 5.7047L6.51867 0.145392C6.7197 -0.0605083 7.03799 -0.0605083 7.23901 0.145392C7.44004 0.351292 7.44004 0.677301 7.23901 0.883201L1.84484 6.44251C1.76108 6.51114 0.0691158 8.31277 1.84484 10.1316C3.5703 11.8989 5.26227 10.3203 5.44654 10.1316L10.4889 4.94973C10.4889 4.94973 10.7737 4.65804 10.9077 4.24624C11.0752 3.69717 10.958 3.21674 10.4889 2.7363C9.48379 1.7068 8.51217 2.56472 8.3279 2.7363L3.63731 7.52348C3.46979 7.69507 3.35253 7.98676 3.63731 8.27845C3.9221 8.57014 4.19013 8.43288 4.35765 8.27845L7.60756 4.94973C7.80858 4.76099 8.14363 4.76099 8.3279 4.94973C8.52892 5.15563 8.52892 5.4988 8.3279 5.7047L5.07799 9.01626C4.62569 9.46238 3.70432 9.8227 2.91697 9.01626C2.11287 8.20982 2.46467 7.24895 2.91697 6.80283Z",
    fill: "#251163"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.7739edb71368c45c54a68264ffd593f3.svg";
export { ForwardRef as ReactComponent };